const baseHost = 'http://39.104.113.243:8888';

import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { Message } from 'element-ui'

// create an axios instance
const service = axios.create({
    baseURL: baseHost, // api 的 base_url
    withCredentials: true, // 跨域请求时发送 cookies
    timeout: 5000 // request timeout
});

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.status !== 200) {
            Message({
                message: res.msg,
                type: 'error',
                duration: 3 * 1000
            })
        } else {
            return res
        }
    },
    error => {
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        });
    }
);

export default service
